import clsx from 'clsx';
import React from 'react';
import styles from './Requisites.module.scss';

export const Requisites: React.FC = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Реквизиты</h1>
            <div className={styles.content}>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>Полное наименование</div>
                    <div className={styles.rowText}>
                        Общество с ограниченной ответственностью «Единая система
                        торговых процедур»
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>Сокращенное название</div>
                    <div className={styles.rowText}>ООО «ЕСТП»</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>Юридический адрес</div>
                    <div className={styles.rowText}>
                        115035, г.Москва, ул. Садовническая, д.14, стр. 2, офис
                        422
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>
                        Офис приема документов
                    </div>
                    <div className={styles.rowText}>
                        191187, г.Санкт-Петербург, ул. Шпалерная, д.2/4
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>ИНН</div>
                    <div className={styles.rowText}>7701986754</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>КПП</div>
                    <div className={styles.rowText}>770501001</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>ОГРН</div>
                    <div className={styles.rowText}>1137746066490</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>Банк</div>
                    <div className={styles.rowText}>
                        ФИЛИАЛ «САНКТ-ПЕТЕРБУРГСКИЙ» АО «АЛЬФА-БАНК»
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>К/сч</div>
                    <div className={styles.rowText}>30101810600000000786</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>БИК</div>
                    <div className={styles.rowText}>044030786</div>
                </div>
                <div className={styles.row}>
                    <div className={styles.rowTitle}>Расчётный счет</div>
                    <div className={styles.rowText}>40702810432000003746</div>
                </div>
            </div>
            <div className={styles.links}>
                <a
                    download
                    href="/assets/requisites/requisites.pdf"
                    className={clsx(styles.link, styles.redLink)}
                >
                    Скачать в PDF
                </a>
                <a
                    download
                    href="/assets/requisites/requisites.docx"
                    className={styles.link}
                >
                    Скачать в DOCX
                </a>
            </div>
        </div>
    );
};
